import injector from 'vue-inject'
import Item from '@/common/model/Item'
import * as Questions from '@/common/model/questions/questions'
import Option from '@/common/model/Option'

const capitalizeFirstLetter = string => string.charAt(0).toUpperCase() + string.slice(1)

const CartElementBuilder = {}
CartElementBuilder.buildItem = (objRef, menu) => new Item(objRef, menu, CartElementBuilder)
CartElementBuilder.buildQuestion = (id, objRef, menu) =>
  new Questions[capitalizeFirstLetter(menu.questions[id].type)](id, objRef, menu, CartElementBuilder)
CartElementBuilder.buildOption = (id, objRef, menu) => new Option(id, objRef, menu, CartElementBuilder)

injector.constant('CartElementBuilder', CartElementBuilder)
